import { memo } from 'react'

import { DataSchemaItemFragment } from 'generated/resources/graphql'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import type { MappedFields } from 'modules/employees/pages/ImportProcessPage/components/ImportProcessWizard/types'

const getOptions = (
  fields: Props['fields'],
  mappedFields?: MappedFields[],
  selectedValue?: Props['selectedValue']
) => {
  const isDisabledField = (fieldName: string) => {
    return (
      mappedFields?.some((mappedField) => mappedField.fieldName === fieldName) &&
      selectedValue != fieldName.toString()
    )
  }
  return fields.map(({ label, fieldName }) => {
    return (
      <Selector.Option
        key={fieldName}
        value={fieldName}
        label={label}
        isDisabled={isDisabledField(fieldName)}
        searchValue={label}
      >
        {label}
      </Selector.Option>
    )
  })
}

type Props = {
  fields: DataSchemaItemFragment[]
  selectedValue: string | unknown
  index: number
  onFieldSelect?: (fieldname?: string, columnIndex?: number) => void
  isDisabled?: boolean
  mappedFields?: MappedFields[]
}

const MapSelector = ({
  fields,
  selectedValue,
  index,
  onFieldSelect,
  isDisabled,
  mappedFields,
}: Props) => {
  return (
    <Selector.Popover
      placeholder={i18n.t('importer_process.map_columns_step.fields.map_selector.placeholder')}
      value={selectedValue ? [`${selectedValue}`] : []}
      blankLabel={i18n.t('common.empty')}
      onChange={(value) =>
        onFieldSelect && onFieldSelect(value ? value.toString() : undefined, index)
      }
      isDisabled={isDisabled}
    >
      {getOptions(fields, mappedFields, selectedValue)}
    </Selector.Popover>
  )
}

function arePropsEqual(oldProps: Props, newProps: Props) {
  if (oldProps.selectedValue !== newProps.selectedValue) {
    return false
  }

  if (JSON.stringify(oldProps.fields) !== JSON.stringify(newProps.fields)) {
    return false
  }

  if (oldProps.index !== newProps.index) {
    return false
  }

  if (oldProps.isDisabled !== newProps.isDisabled) {
    return false
  }

  if (JSON.stringify(oldProps.mappedFields) !== JSON.stringify(newProps.mappedFields)) {
    return false
  }

  return true
}

export default memo(MapSelector, arePropsEqual)
